import { apiFetch } from '../apiFetch'

export const getPlace = async (id) => {
  return await apiFetch({
    path: `/locations/${id}`
  })
}

export const getLocations = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  return await apiFetch({
    path: `/locations${query ? `?${query}` : ''}`
  })
}

export const getNearbyPlaces = async (lat, lng, limit = 25) =>
  apiFetch({ path: `/places?lat=${lat}&lng=${lng}&limit=${limit}`, method: 'get' })

export const getHostLocations = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  return await apiFetch({
    path: `/host/places${query ? `?${query}` : ''}`
  })
}
